import React, { Fragment } from "react";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  Typography,
} from "@mui/material";
import { Controller } from "react-hook-form";
import checkBoxIcon from "assets/wealth/icons/check_box.svg";
import checkBoxCheckedIcon from "assets/wealth/icons/check_box_checked.svg";
import TextOtherField from "../TextOtherField";
import ErrorMessage from "components/form/ErrorMessage";
import useDevice from "hooks/useDevice";
import { areAbsolutelyEqual } from "helpers/commonFunctions";

export const CheckBox = ({ field, listAnswer, control, name, disabled }) => {
  const { isMobile } = useDevice();
  const handleChange = (answerId, answer) => (event) => {
    const value = field.value || [];
    const index = value.findIndex((item) => item.answerId === answerId);
    if (index >= 0) {
      value.splice(index, 1);
    }
    if (event.target.checked) {
      if (answer?.subType === "OTHER_ANSWER") {
        value.push({ answerId, text: "" });
      } else {
        value.push({ answerId });
      }
    }
    field.onChange([...value]);
  };
  const checkIndex = (answerId) => {
    const value = field.value || [];
    return value.findIndex((item) => item.answerId === answerId);
  };
  return (
    <FormGroup
      sx={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        marginLeft: "-4px",
        marginRight: "-4px",
      }}
    >
      {listAnswer.map((answer) => (
        <Fragment key={answer.elementId}>
          <FormControlLabel
            ref={field.ref}
            label={answer.title}
            control={
              <Checkbox
                disabled={disabled}
                icon={<img style={{ width: 16 }} src={checkBoxIcon} alt="" />}
                checkedIcon={
                  <img style={{ width: 16 }} src={checkBoxCheckedIcon} alt="" />
                }
                onChange={handleChange(answer.elementId, answer)}
                checked={
                  checkIndex(answer.elementId) >= 0 ||
                  areAbsolutelyEqual(answer?.answerText, answer?.title) ||
                  (answer.answerText !== null && answer.subType === "OTHER_ANSWER")
                }
              />
            }
            sx={{
              "& .MuiFormControlLabel-label": {
                fontSize: "0.875rem",
                flex: "1 1",
                wordWrap: "break-word",
                maxWidth: isMobile ? "calc(100% - 2rem)" : "unset",
              },
              "& .MuiFormControlLabel-label.Mui-disabled": {
                color: "#000000",
              },
              "& .MuiCheckbox-root": {
                padding: "4px",
                marginRight: "8px",
                flexShrink: 0,
              },
              alignItems: "flex-start",
              margin: 0,
              marginBottom: "4px",
              minWidth: isMobile ? "100%" : "calc((100% - 16px) / 3)",
              maxWidth: isMobile ? "100%" : "calc((100% - 16px) / 3)",
            }}
          />
          {((checkIndex(answer.elementId) >= 0 &&
            answer.subType === "OTHER_ANSWER") ||
            (answer.answerText !== null && answer.subType === "OTHER_ANSWER")) && (
            <TextOtherField
              control={control}
              name={`${name}.${checkIndex(answer.elementId)}.text`}
              answer={answer}
              disabled={disabled}
              value={answer.answerText}
            />
          )}
        </Fragment>
      ))}
    </FormGroup>
  );
};
export default function MultipleChoiceField({
  control,
  name,
  question,
  listAnswer,
  questionIdx,
  disabled,
}) {
  return (
    <Grid item xs={12} className="!mb-4">
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "14px",
          color: "#00B74F",
          mb: 0.5,
        }}
      >
        Câu {questionIdx + 1}:
      </Typography>
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "14px",
          color: "#25282B",
          mb: 1,
          wordWrap: "break-word",
        }}
        className="question-title"
      >
        {question.title}
      </Typography>
      <Controller
        control={control}
        name={name}
        render={({ field, fieldState: { error } }) => {
          return (
            <>
              <FormHelperText error>
                <ErrorMessage message={error?.message} />
              </FormHelperText>
              <CheckBox
                field={field}
                control={control}
                name={name}
                listAnswer={listAnswer}
                disabled={disabled}
              />
            </>
          );
        }}
      />
      <div
        className="pt-2"
        dangerouslySetInnerHTML={{ __html: question?.description }}
      />
    </Grid>
  );
}
